import React from "react";
import moment from "moment";
import { formatWrittenDayMonthYear } from "utilities";

interface Props {
  value: string
}

const ReadonlyDate = (props: Props) => {
  const momentValue = moment.utc(props.value);

  return <>{formatWrittenDayMonthYear(momentValue)}</>;
};

export default ReadonlyDate;